// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tf-form-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
    padding: 20px;
    box-sizing: border-box;
    overscroll-behavior: contain;
}

.tf-form-popup {
    background: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    position: relative;
    max-width: 70%;
    max-height: 80%;
    overflow: hidden;
}

.tf-form-popup-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.form-title{
    font-size: 32px;
  margin: 0;
  font-weight: 700;
}

.tfm-close-button{
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    font-size: 1rem;
    color: #f00202;
    cursor: pointer;
}

@media (max-width: 768px) {
    .tf-form-popup-overlay {
        align-items: flex-end;
        padding: 8px 8px max(8px, env(safe-area-inset-bottom));
        background: rgba(15, 23, 42, .72);
        backdrop-filter: blur(4px);
    }

    .tf-form-popup {
        width: 100%;
        max-width: 100%;
        height: min(94dvh, 94vh);
        max-height: min(94dvh, 94vh);
        padding: 12px;
        border-radius: 22px 22px 14px 14px;
        justify-content: flex-start;
        align-items: stretch;
        animation: mobileFormSheetIn .25s ease both;
    }

    .tf-form-popup::before {
        content: "";
        width: 42px;
        height: 4px;
        flex: 0 0 4px;
        margin: 0 auto 8px;
        border-radius: 999px;
        background: #cbd5e1;
    }

    .tf-form-popup-header {
        position: sticky;
        z-index: 10;
        top: 0;
        flex: 0 0 auto;
        min-height: 48px;
        padding: 4px 4px 10px;
        background: #fff;
    }

    .form-title {
        padding-right: 48px;
        font-size: 21px;
        line-height: 1.25;
    }

    .tfm-close-button {
        top: 12px;
        right: 14px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #fff1f2;
        font-size: 0;
    }

    .tfm-close-button::after {
        content: "×";
        font-size: 25px;
        line-height: 1;
    }

    .tf-form-popup > :last-child:not(.tf-form-popup-header) {
        min-height: 0;
        max-width: 100%;
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-width: none;
    }

    .tf-form-popup > :last-child::-webkit-scrollbar {
        display: none;
    }
}

@media (max-width: 600px) {
    .tf-form-popup {
        width: 100%;
        padding: 12px;
    }
}

.tf-form-popup.tf-form-popup-wide {
    width: min(920px, 95vw);
    max-width: 95vw;
    max-height: 92vh;
    padding: 0;
    overflow: hidden;
}

@media (max-width: 768px) {
    .tf-form-popup.tf-form-popup-wide {
        width: 100%;
        max-width: 100%;
        height: min(94dvh, 94vh);
        max-height: min(94dvh, 94vh);
        padding: 0;
    }
}

@keyframes mobileFormSheetIn {
    from { opacity: 0; transform: translateY(40px); }
    to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/forms/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,qBAAqB;QACrB,sDAAsD;QACtD,iCAAiC;QACjC,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,wBAAwB;QACxB,4BAA4B;QAC5B,aAAa;QACb,kCAAkC;QAClC,2BAA2B;QAC3B,oBAAoB;QACpB,2CAA2C;IAC/C;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,MAAM;QACN,cAAc;QACd,gBAAgB;QAChB,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,4BAA4B;QAC5B,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,wBAAwB;QACxB,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":[".tf-form-popup-overlay {\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1001;\n    padding: 20px;\n    box-sizing: border-box;\n    overscroll-behavior: contain;\n}\n\r\n.tf-form-popup {\n    background: white;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px;\r\n    position: relative;\r\n    max-width: 70%;\r\n    max-height: 80%;\n    overflow: hidden;\n}\n\r\n.tf-form-popup-header{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.form-title{\r\n    font-size: 32px;\r\n  margin: 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.tfm-close-button{\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 1rem;\r\n    color: #f00202;\r\n    cursor: pointer;\r\n}\r\n\r\n@media (max-width: 768px) {\n    .tf-form-popup-overlay {\n        align-items: flex-end;\n        padding: 8px 8px max(8px, env(safe-area-inset-bottom));\n        background: rgba(15, 23, 42, .72);\n        backdrop-filter: blur(4px);\n    }\n\n    .tf-form-popup {\n        width: 100%;\n        max-width: 100%;\n        height: min(94dvh, 94vh);\n        max-height: min(94dvh, 94vh);\n        padding: 12px;\n        border-radius: 22px 22px 14px 14px;\n        justify-content: flex-start;\n        align-items: stretch;\n        animation: mobileFormSheetIn .25s ease both;\n    }\n\n    .tf-form-popup::before {\n        content: \"\";\n        width: 42px;\n        height: 4px;\n        flex: 0 0 4px;\n        margin: 0 auto 8px;\n        border-radius: 999px;\n        background: #cbd5e1;\n    }\n\n    .tf-form-popup-header {\n        position: sticky;\n        z-index: 10;\n        top: 0;\n        flex: 0 0 auto;\n        min-height: 48px;\n        padding: 4px 4px 10px;\n        background: #fff;\n    }\n\n    .form-title {\n        padding-right: 48px;\n        font-size: 21px;\n        line-height: 1.25;\n    }\n\n    .tfm-close-button {\n        top: 12px;\n        right: 14px;\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        background: #fff1f2;\n        font-size: 0;\n    }\n\n    .tfm-close-button::after {\n        content: \"×\";\n        font-size: 25px;\n        line-height: 1;\n    }\n\n    .tf-form-popup > :last-child:not(.tf-form-popup-header) {\n        min-height: 0;\n        max-width: 100%;\n        overflow-y: auto;\n        overscroll-behavior: contain;\n        scrollbar-width: none;\n    }\n\n    .tf-form-popup > :last-child::-webkit-scrollbar {\n        display: none;\n    }\n}\n\n@media (max-width: 600px) {\n    .tf-form-popup {\n        width: 100%;\n        padding: 12px;\n    }\n}\n\n.tf-form-popup.tf-form-popup-wide {\n    width: min(920px, 95vw);\n    max-width: 95vw;\n    max-height: 92vh;\n    padding: 0;\n    overflow: hidden;\n}\n\n@media (max-width: 768px) {\n    .tf-form-popup.tf-form-popup-wide {\n        width: 100%;\n        max-width: 100%;\n        height: min(94dvh, 94vh);\n        max-height: min(94dvh, 94vh);\n        padding: 0;\n    }\n}\n\n@keyframes mobileFormSheetIn {\n    from { opacity: 0; transform: translateY(40px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
